export default __webpack_public_path__ + "static/media/cattleytics-logo-transparent.c549bc82.png";